import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { ApiResponse, BasicApiResponse, ListResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

const jsonHeaders = { "content-type": "application/json" };

type FetchAllGroupsPayload = {
    ids: number[];
    userEmail: string;
    workspaceId: number;
    includeStatistics: boolean;
};
export async function fetchAllGroups(payload?: Partial<FetchAllGroupsPayload>) {
    try {
        const endpoint = await RouteService.getAdminGroupsRoute();
        const { data } = await HttpService.get<string, AxiosResponse<ListResponse<API.Group>>>(endpoint, {
            data: "",
            headers: jsonHeaders,
            params: payload,
        });
        return data.list;
    } catch (error) {
        throw unpackError(error);
    }
}

type MoveGroupLicensesPayload = {
    sourceId: number;
    targetGroupId: number;
};

export async function moveGroupLicenses({ sourceId, targetGroupId }: MoveGroupLicensesPayload) {
    try {
        const endpoint = await RouteService.getAdminGroupsRoute();
        const { data } = await HttpService.patch<{ targetGroupId: number }, AxiosResponse<ApiResponse<API.Group>>>(
            `${endpoint}${sourceId}/licenses`,
            { targetGroupId },
            { headers: jsonHeaders },
        );
        return data.model;
    } catch (error) {
        throw unpackError(error);
    }
}

type RevokeGroupLicensesPayload = {
    id: number;
    reason?: string;
};

export async function revokeGroupLicenses({ id, reason }: RevokeGroupLicensesPayload) {
    try {
        const endpoint = await RouteService.getAdminGroupsRoute();
        const trimmedReason = reason?.trim();
        const { data } = await HttpService.delete<string, AxiosResponse<BasicApiResponse>>(`${endpoint}${id}/licenses`, {
            data: trimmedReason ? { reason: trimmedReason } : {},
            headers: jsonHeaders,
        });
        return data;
    } catch (error) {
        throw unpackError(error);
    }
}

type DeleteGroupPayload = {
    id: number;
    force: boolean;
};

export async function deleteGroup({ id, force }: DeleteGroupPayload) {
    try {
        const endpoint = await RouteService.getAdminGroupsRoute();
        await HttpService.delete(`${endpoint}${id}`, {
            data: { force },
            headers: jsonHeaders,
        });
    } catch (error) {
        throw unpackError(error);
    }
}
